import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { NewsReward } from '../../../../models/news/news-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-news-reward-edit-modal',
  templateUrl: './news-reward-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsRewardEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  rewardId: number = 0;
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiNewsService: ApiNewsService, private alertsService: AlertsService) {}

  show(reward: NewsReward, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.rewardId = reward.rewardId;
    this.currencyType = reward.currencyType;
    this.currencyQuantity = reward.currencyQuantity;
    this.currencyTicketCost = reward.currencyTicketCost;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.editNewsReward(this.rewardId, this.currencyType, this.currencyQuantity, this.currencyTicketCost).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Reward updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating reward : ' + error);
      }
    );
  }
}
